import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    position: 'relative',
    backgroundColor: theme.palette.text.white,
  },
  description: {
    color: theme.palette.labraText.secondary,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  cardsWrapper: {
    padding: theme.spacing(4, 8, 3, 5),
    margin: theme.spacing(0, -4, 0, -4),
    backgroundColor: theme.palette.text.white,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  horizontalDivider: {
    height: theme.spacing(0.125),
    width: '100%',
    backgroundColor: theme.palette.dividerV2.main,
  },
  sectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
    height: 'auto',
  },
  footerActions: {
    width: '920px',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(0.5),
  },
  scrollTopMargin: {
    scrollMarginTop: '164px',
    gap: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
  },
  stickyTabsContainer: {
    position: 'sticky',
    zIndex: theme.zIndex.appBar,
    top: '64px',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxHeight: theme.spacing(5),
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(4, 5, 0, 5),
    margin: theme.spacing(-4, -4, 0, -4),
    boxShadow: `${theme.palette.labraV2BoxShadow.dark} 0px -1px 0`,
  },
  textHeading: {
    color: '#381E1C',
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.25px',
  },
}))
